// Domain 05 — Infrastructure Services (RouteZero Data Center, Clark / Angeles)
import u01 from './u01-services-overview.js';
import u02 from './u02-dhcp-fundamentals.js';
import u03 from './u03-dhcp-relay.js';
import u04 from './u04-dhcp-troubleshooting.js';
import u05 from './u05-dns-fundamentals.js';
import u06 from './u06-nat-fundamentals.js';
import u07 from './u07-nat-pat-config.js';
import u08 from './u08-nat-troubleshooting.js';
import u09 from './u09-fhrp-fundamentals.js';
import u10 from './u10-hsrp.js';
import u11 from './u11-vrrp-glbp.js';
import u12 from './u12-ntp.js';
import u13 from './u13-snmp-syslog.js';
import u14 from './u14-final.js';

export default {
  id: 'd05', number: '05', title: 'Infrastructure Services',
  tagline: 'DHCP and relay, DNS, NAT/PAT, first-hop redundancy (HSRP, VRRP, GLBP), NTP, Syslog and SNMP in RouteZero\'s Clark data center.',
  units: [u01, u02, u03, u04, u05, u06, u07, u08, u09, u10, u11, u12, u13, u14],
};
